export const Header = [{
  prop: 'USER_NAME',
  label: '采购人'
}, {
  prop: 'CHEM_NAME',
  label: '试剂名称'
}, {
  prop: 'CHEM_ID',
  label: 'CAS号'
}, {
  prop: 'COMPANY_SALE',
  label: '销售产商'
}, {
  prop: 'COMPANY_SRC',
  label: '生产厂商'
}, {
    prop: 'PURTY',
    label: '纯度'
}, {
    prop: 'PRICE',
    label: '单价'
},{
    prop: 'ALL_PRICE',
    label: '总价'
}, {
    prop: 'NUM',
    label: '数量'
}]

